import { useGetApiV1SerievideoSeriesSerieid } from '@/shared/api/generated';
import type { SerieVideoFilters } from '../types/serieVideoFilters';

/** Itens por página da listagem de Vídeos (paginação server-side). */
export const SERIE_VIDEO_PAGE_SIZE = 20;

/**
 * Hook para listar os Vídeos de uma Série, com busca e paginação **server-side**.
 *
 * Envolve o hook gerado pelo Kubb para `GET /api/v1/serievideo/series/{serieId}`.
 *
 * @param serieId - ID da série
 * @param filters - Filtros de busca/paginação atuais
 *
 * @example
 * ```tsx
 * const { videos, totalCount, isLoading } = useSerieVideoList(serieId, filters);
 * ```
 */
export function useSerieVideoList(serieId: number, filters: SerieVideoFilters) {
  const query = useGetApiV1SerievideoSeriesSerieid(serieId, {
    ...(filters.search ? { search: filters.search } : {}),
    page: filters.page,
    pageSize: SERIE_VIDEO_PAGE_SIZE,
  });

  return {
    videos: query.data?.data ?? [],
    totalCount: query.data?.totalCount ?? 0,
    totalPages: query.data?.totalPages ?? 1,
    currentPage: query.data?.currentPage ?? filters.page,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  } as const;
}
